import { Card } from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";

export default function CTA() {
  return (
    <Card className="bg-primary flex flex-col items-center justify-center text-white rounded-lg shadow-lg text-center">
      <h2 className="text-2xl md:text-3xl font-bold">
        Ready to Experience the Difference?
      </h2>
      <p className="text-lg text-slate-300 max-w-3xl mx-auto">
        Upload transcripts and get accurate US-based grade conversions in
        minutes. Download your professionally formatted PDF immediately.
      </p>
      <Link to="/dashboard">
        <button className="group relative inline-flex gap-x-2 h-12 z-20 items-center justify-center overflow-hidden border-2 border-primary rounded-md bg-white px-8 font-medium text-primary transition-all duration-100 [box-shadow:3px_3px_rgb(40_75_98)] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(40_75_98)] ">
          Try AI Conversion Now
          <ArrowUpRight className="text-primary" />
        </button>
      </Link>
    </Card>
  );
}
